import { getUserInfo, login, logout as logoutApi } from '@/api/user'
import type { LoginParam, UserInfo } from '@/types/user'
import { setItem } from '@/utils/storage'
import { defineStore } from 'pinia'

export const useUserInfoStore = defineStore('userInfo', {
  state: () => ({
    user: {} as UserInfo,
    collapse: false,
    tabList: [] as { title: string; path: string }[]
  }),
  getters: {
    avatar: (state) => {
      return state.user.avatar || '/images/avatar_boy.jpeg'
    }
  },
  actions: {
    async login(loginForm: LoginParam) {
      const token = await login(loginForm)
      setItem('token', token)
    },
    async getUserInfo() {
      try {
        this.user = await getUserInfo()
      } catch (e) {
        // 后端不可用时保持空对象
        console.warn('获取用户信息失败')
      }
    },
    async logout() {
      try {
        await logoutApi()
      } catch (e) {
        // ignore
      }
      window.localStorage.clear()
      this.$reset()
    },
    switchFolding() {
      this.collapse = !this.collapse
    }
  },
  persist: true
})
